import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommandMenuItem } from '../../../core/entities/commandMenuItem/command-menu-item';
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Reloadable } from '../../../core/services/command/command.service';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Contact } from 'src/app/rent-module/shared/entities/contact/contact';
import { Task } from 'src/app/rent-module/shared/entities/task/task';
import { TasksService } from 'src/app/rent-module/shared/services/tasks/tasks.service';
import { AddressDialogComponent } from 'src/app/shared-module/components/address-dialog/address-dialog.component';
import { Address } from 'src/app/shared-module/shared/entities/address/address';
import { AddressService } from 'src/app/tour-planning/shared/services/address/address.service';


@Component({
  selector: 'div[task-row], app-task-row-component',
  templateUrl: './task-row.component.html',
  styleUrls: ['./task-row.component.scss'],
})
export class TaskRowComponent implements Reloadable{

  // attribute is to store a string to compare, if the menu items has changed
  private commandsString: string = undefined;
  menuItems: MenuItem[];

  dialogRef: DynamicDialogRef | undefined;
  _task: Task;
  @Input() set task(task: Task) {
    if(task){
      this._task = task;
      this.buildMenuItems();
    }
  };
  @Input() showCommandMenu: boolean = false;
  @Input() showAddress: boolean = true;
  @Input() showOrderNote: boolean = false;
  @Input() showCompletedStateLabel: boolean = false;
  @Input() showStateLabel: boolean = false;
  @Output() refetchTasks = new EventEmitter();

  constructor(
    public tasksService: TasksService,
    private datePipe: DatePipe,
    private router: Router,
    private addressService: AddressService,
    public dialogService: EditDialogService,
    public commandService: CommandService,
    private translate: TranslateService
   ){
  }


  isEllipsisActive(e: { offsetWidth: number; scrollWidth: number; }) {
    return !(e.offsetWidth < e.scrollWidth);
  }

  buildArticleString(taskPositions: any[]){
    let articleNumberString = "";
    if(taskPositions && taskPositions.length > 0){
      for (let index = 0; index < taskPositions.length; index++) {
        const element = taskPositions[index];
        articleNumberString = articleNumberString + taskPositions[index].articleNumber;
        if(index < taskPositions.length -1){
          articleNumberString = articleNumberString + ", ";
        }
      }
    }
    return articleNumberString;
  }

  goToOrder(task: Task){
    if(task && task.order && task.order.id){
      this.router.navigate(["./orders/order/" + task.order.id]);
    }
  }

  getContactName(contact: Contact): string {
    return new Contact(contact).getFullName();
  }

  getAddressToolTip(address: Address) {
    if(!address) {
      return null;
    }
    let addressToolTip = address.getAddressString();
    // add the note of the address to the tooltip
    if(address.note){
      addressToolTip += ", " + address.note;
    }
    return addressToolTip;
  }

  public commandMenuItems: CommandMenuItem[] = [
    {
      label: this.translate.instant('sharedModule.taskRowComponent.menu.editAddress'),
      command: 'editAddress',
      disabled: function() : boolean {
        return !this.data?.address;
      }
    },
    {
      label: this.translate.instant('sharedModule.taskRowComponent.menu.acceptAddress'),
      command: 'editAddress',
      disabled: function() : boolean {
        return this.data?.address?.geocodingResultGrade !== 'YELLOW'}
    }
  ]

  executeCommand($event){
    if($event.command === 'editAddress'){
      this.editAddress($event.data);
    }
    if($event.command === 'acceptAddress'){
      this.acceptAddress($event.data);
    }
  }

  acceptAddress(task: Task) {
    //this.dsLoading = true;
    this.addressService.acceptAddress(task?.address?.id, () => {
      this.refetchTasks.emit();
    });
  }

  editAddress(task: Task) {
    console.log(task);
    this.dialogRef = this.dialogService.open(AddressDialogComponent, {
      width: "1100px",
      header: this.translate.instant('sharedModule.taskRowComponent.dialog.editAddress.header'),
      data: {
        address: task.address,
      }
    });
    this.dialogRef.onClose.subscribe((result: any) => {
      if(result){
        this.addressService.updateAddress(result.addressInput, (result: any) => {
          this.refetchTasks.emit();
        });
      }
    });
  }

  getAddressString(task: Task){
    let addressString = "";
    if(task?.address){
      if(task?.address?.postalCode ){
        addressString += task?.address?.postalCode;
      }
      if(task?.address?.city){
        addressString += addressString.length > 0 ? " " + task?.address?.city :  task?.address?.city;
      }
    }
    if(addressString?.length === 0){
      addressString = "-";
    }
    return addressString;
  }

  shouldShowOrderNoteButton(): boolean{
    if(!this.showOrderNote){
      return false;
    }
    switch (this._task?.type) {
      case 'nexcore_rental_resourceAssignmenmt_out':
      case 'nexcore_rental_resourceAssignmenmt_in':
      case 'nexcore_rental_resourceAssignmenmt_refuel':
      case 'nexcore_rental_resourceAssignmenmt_review': 
        return true;
      default: 
        return false;
    }
  }

  /**
   * This method builds the context menu for each row. It stores a string represenation of all 
   * commands to compare if the commands have changed. If they have changed, the menu items are rebuild.
   * This is because of weird behaviour of the primeng menu component.
   */
  buildMenuItems() {
    console.log('buildMenuItems');
    if(this._task?.commands?.length > 0 && this.commandsString !== JSON.stringify(this._task?.commands)){
      this.commandsString = JSON.stringify(this._task?.commands);
      this.menuItems = [];
      this._task?.commands.forEach( (command: CommandTemplate) => {
        this.menuItems.push({
          label: command.settings?.label,
          disabled: command.settings?.disabled,
          command: () => {
            this.commandService.execute(this._task, command, this);
          }
        });
      });
    } else {
      this.commandsString = '';
    } 
  }

  reload(): void {
    this.refetchTasks.emit();
  }
}
